var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSec1Icon8(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sec1Icon8",
    transform: "translate(-990 -898)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_4862",
    "data-name": "\\uC0AC\\uAC01\\uD615 4862",
    width: 50,
    height: 50,
    rx: 12,
    transform: "translate(990 898)",
    fill: "#f2f4f6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_x31_0",
    transform: "translate(997.256 906.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33728",
    "data-name": "\\uD328\\uC2A4 33728",
    d: "M9.86,4.137,5.148,8.431l-.425-.449-.757-.806A.838.838,0,0,1,4,6.007l3.39-3.273a.83.83,0,0,1,1.181.025l.874.929Z",
    transform: "translate(0 0)",
    fill: "#474646"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56397",
    "data-name": "\\uADF8\\uB8F9 56397",
    transform: "translate(4.209 3.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33729",
    "data-name": "\\uD328\\uC2A4 33729",
    d: "M32.034,7.09V28.751a3.291,3.291,0,0,1-3.321,3.26H7.822A3.291,3.291,0,0,1,4.5,28.751V10.409a1.616,1.616,0,0,1,.542-1.2l5.534-4.949a1.678,1.678,0,0,1,1.118-.425H28.712a3.291,3.291,0,0,1,3.321,3.26Z",
    transform: "translate(-4.501 -3.83)",
    fill: "#3d476b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56398",
    "data-name": "\\uADF8\\uB8F9 56398",
    transform: "translate(26.804 3.318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33730",
    "data-name": "\\uD328\\uC2A4 33730",
    d: "M46.166,7.091V28.751a3.294,3.294,0,0,1-3.322,3.261H41.226a3.29,3.29,0,0,0,3.322-3.261V7.091a3.29,3.29,0,0,0-3.322-3.261h1.618A3.294,3.294,0,0,1,46.166,7.091Z",
    transform: "translate(-41.226 -3.831)",
    fill: "#313a56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33731",
    "data-name": "\\uD328\\uC2A4 33731",
    d: "M23.922,25.787V20.555a3.888,3.888,0,0,1,1.139-2.75l1.046-1.046a.551.551,0,1,0-.778-.78l-1.047,1.047a3.888,3.888,0,0,1-2.749,1.138H16.294a3.888,3.888,0,0,1-2.749-1.138L12.5,15.98a.551.551,0,0,0-.778.78l1.046,1.046a3.888,3.888,0,0,1,1.139,2.75v5.232a3.888,3.888,0,0,1-1.139,2.749L11.72,29.583a.55.55,0,1,0,.778.778l1.046-1.046a3.888,3.888,0,0,1,2.749-1.139h5.24a3.888,3.888,0,0,1,2.749,1.139l1.046,1.046a.55.55,0,1,0,.778-.778l-1.046-1.046a3.888,3.888,0,0,1-1.139-2.749Zm-8.268-6.521h6.519a.648.648,0,0,1,.648.648v6.513a.648.648,0,0,1-.648.648H15.654a.648.648,0,0,1-.648-.648V19.914A.648.648,0,0,1,15.654,19.266Z",
    transform: "translate(-0.937 -3.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33732",
    "data-name": "\\uD328\\uC2A4 33732",
    d: "M35.988,8.492h0a1.922,1.922,0,0,1-1.922,1.922H25.43a1.922,1.922,0,0,1-1.922-1.922h0A1.922,1.922,0,0,1,25.43,6.57h8.635a1.922,1.922,0,0,1,1.922,1.922Z",
    transform: "translate(-7.605 -1.566)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33733",
    "data-name": "\\uD328\\uC2A4 33733",
    d: "M35.681,7.457a1.865,1.865,0,0,0-1.052-.32H26a1.928,1.928,0,0,0-1.926,1.926,1.833,1.833,0,0,0,.314,1.04,1.918,1.918,0,0,1,1.046-3.531h8.632a1.919,1.919,0,0,1,1.618.886Z",
    transform: "translate(-7.604 -1.567)",
    fill: "#e4e3ff",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33734",
    "data-name": "\\uD328\\uC2A4 33734",
    d: "M10.473,4.137l-.4.363L5.76,8.431l-.425-.449,3.4-3.088A1.237,1.237,0,0,0,8.8,3.14a.833.833,0,0,0-1.181-.025L8,2.734a.83.83,0,0,1,1.181.025l.874.929Z",
    transform: "translate(-0.612)",
    fill: "#2d2c2c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56401",
    "data-name": "\\uADF8\\uB8F9 56401",
    transform: "translate(5.676 12.806)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56399",
    "data-name": "\\uADF8\\uB8F9 56399",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33735",
    "data-name": "\\uD328\\uC2A4 33735",
    d: "M7.345,29.923a.462.462,0,0,1-.461-.461v-5.64a.461.461,0,0,1,.923,0v5.64a.462.462,0,0,1-.461.461Z",
    transform: "translate(-6.884 -23.361)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56400",
    "data-name": "\\uADF8\\uB8F9 56400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33736",
    "data-name": "\\uD328\\uC2A4 33736",
    d: "M7.345,21.421a.462.462,0,0,1-.461-.461v-.8a.461.461,0,1,1,.923,0v.8a.462.462,0,0,1-.461.461Z",
    transform: "translate(-6.884 -19.694)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56403",
    "data-name": "\\uADF8\\uB8F9 56403",
    transform: "translate(18.45 29.777)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56402",
    "data-name": "\\uADF8\\uB8F9 56402"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33737",
    "data-name": "\\uD328\\uC2A4 33737",
    d: "M27.647,48.164a.462.462,0,0,1,.461-.461h5.64a.461.461,0,0,1,0,.923h-5.64A.462.462,0,0,1,27.647,48.164Z",
    transform: "translate(-27.647 -47.702)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56405",
    "data-name": "\\uADF8\\uB8F9 56405",
    transform: "translate(16.791 3.698)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56404",
    "data-name": "\\uADF8\\uB8F9 56404",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33738",
    "data-name": "\\uD328\\uC2A4 33738",
    d: "M24.951,4.91a.462.462,0,0,1,.461-.461h5.64a.461.461,0,1,1,0,.923h-5.64A.462.462,0,0,1,24.951,4.91Z",
    transform: "translate(-24.951 -4.449)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_56406",
    "data-name": "\\uADF8\\uB8F9 56406",
    transform: "translate(4.703 3.993)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_33739",
    "data-name": "\\uD328\\uC2A4 33739",
    d: "M5.37,7.079a.246.246,0,0,1,.011-.348L7.234,4.994a.246.246,0,0,1,.336.359L5.717,7.09a.246.246,0,0,1-.348-.011Z",
    transform: "translate(-5.303 -4.928)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSec1Icon8);
export default __webpack_public_path__ + "static/media/sec1Icon8.bae18c3e5d254c785467bc116c973c75.svg";
export { ForwardRef as ReactComponent };